import React, {FC, useEffect} from 'react';
import './logo-with-site-name.scss'
import {getTokenTime, refreshToken} from "/react4xp/parts/logo-with-site-name/actions";

const LogoWithSiteName: FC = ({config, logoImg, user, className, language, mode}) => {

    const setTimeLimit = (seconds: number) => {
        let time = new Date();

        const limit = seconds * 1000;

        let timer = setInterval(() => {
            let time2 = new Date();

            if (time2 - time >= limit) {
                clearInterval(timer);
                // logout
                open('/ru/_/idprovider/jwt/logout', '_self');
            } else {
                // отправляем запрос на обновление тоукена
                refreshToken().then(() => console.log('Token has been refreshed!'));
            }
        }, limit);

        const root = document.getElementById("root");

        root.addEventListener(
            "mouseover",
            () => {
                time = new Date();
            },
            false,
        );
    };

    useEffect(() => {
        if (mode === 'live' && user) {
            // Получаем время жизни тоукена
            getTokenTime().then(
                value => {
                    setTimeLimit(value.data);
                }
            );
        }
    }, []);

    return (
        <div className={`logo-with-site-name ${className}`} onClick={() => window.open('/' + language, "_self")}>
            {logoImg && (
                <img className="me-2" src={logoImg} />
            )}
            <div>
                <h1><b>{config.titleOne}</b></h1>
                <h1><b>{config.titleTwo}</b></h1>
                <h1>{config.titleThree}</h1>
            </div>
        </div>
    );
};

export default props => <LogoWithSiteName {...props} />;
